// extracted by mini-css-extract-plugin
module.exports = {"scrolled":"Navbar_scrolled__wgQ-v","buttonContainer":"Navbar_buttonContainer__1SOht","active":"Navbar_active__1_PBO"};